import Table from '@components/table'
import TableActions from '@components/table/actions'
import Button from '@components/button'
import Svg from '@components/svg'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useState, useEffect } from 'react'
import { User } from '@apis'
import debounce from '@utils/debounce'
import Row from '@components/row'
import Typography from '@components/typography'
import Column from '@components/column'
import Image from '@components/image'
import Alert from '@commons/popups/alert'
import { Actions, store } from '@store'
const RequestDoctors = () => {
  const navigate = useNavigate()
  const { items: doctors } = useSelector((state: any) => state.doctorRequests)
  const [alertInfo, setAlertInfo] = useState<any>({
    visible: false,
    id: null,
    value: null,
  })
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
    role: 'doctor',
    isApproved: false,
    search: '',
  })
  const columns = [
    {
      key: 'name',
      title: 'Name',
      render: (item) => {
        return (
          <Row alignItems="center" colGap={10}>
            <Image
              src={`${process.env.BUCKET_URL}/${item?.avatar}`}
              width={40}
              height={40}
              styleImage={`border-radius:50%;`}
            />
            <Column rowGap={2}>
              <Typography content={item?.name} size={12} />
              <Typography content={item?.phoneNo} size={12} tc="placeholder" />
              <Typography content={item?.email} size={12} tc="placeholder" />
            </Column>
          </Row>
        )
      },
    },
    {
      key: 'departments',
      title: 'Department',
      render: (item) => {
        return item?.departments
          ?.map((department) => department?.name)
          .toString()
      },
    },
    {
      key: 'specializations',
      title: 'Specialization',
      render: (item) => {
        return item?.specializations
          ?.map((specialization: any) => specialization?.name)
          .toString()
      },
    },
    {
      key: 'qualification',
      title: 'Degree',
      render: (item) => {
        return item?.infos?.qualification
      },
    },

    {
      key: 'actions',
      title: 'Actions',
      render: (item) => {
        return (
          <Row alignItems="center" colGap={10}>
            <TableActions
              onClickView={() => {
                navigate(`/admin/doctors/details/${item?.id}`, {
                  state: item,
                })
              }}
              hasDelete={false}
              hasEdit={false}
            />
            <Column
              onClick={() => {
                setAlertInfo({
                  visible: true,
                  id: item?.id,
                  value: false,
                })
              }}
            >
              <Svg svg="circleCross" color={'danger'} size={20} />
            </Column>
            <Column
              onClick={() => {
                setAlertInfo({
                  visible: true,
                  id: item?.id,
                  value: true,
                })
              }}
            >
              <Svg svg="circleTick" color={'success'} size={20} />
            </Column>
          </Row>
        )
      },
    },
  ]

  const fetchDoctors = async (params) => {
    await User.list({
      params: params,
      state: 'doctorRequests',
    }).catch(() => {})
  }

  const handleSearch = debounce(async (event: any) => {
    const text = event.target.value
    const updateParams = {
      ...params,
      search: text,
    }
    await fetchDoctors(updateParams)
    setParams(updateParams)
  }, 500)

  const handleApprovedOrRejected = async () => {
    await User.updateStatus({
      state: 'doctorRequests',
      action: alertInfo?.value == true ? 'remove' : 'update',
      id: alertInfo?.id,
      data: {
        isApproved: alertInfo?.value,
      },
    })
      .then((resp) => {
        store.dispatch(Actions.prepend('activeDoctors', resp))
        setAlertInfo({
          visible: false,
          id: null,
          value: null,
        })
      })
      .catch(() => {})
  }

  useEffect(() => {
    if (!doctors?.length) {
      fetchDoctors(params)
    }
  }, [])
  return (
    <>
      <Table
        columns={columns}
        data={doctors}
        filter={{
          hasSearch: true,
          onSearch: handleSearch,
          rightComponent: (
            <>
              <Button
                title="Add Doctor"
                leftComponent={<Svg svg="plus" color={'white'} />}
                height={40}
                onClick={() => {
                  navigate('/admin/doctors/create')
                }}
              />
            </>
          ),
        }}
      />
      <Alert
        visible={alertInfo?.visible}
        title={`Approve Request`}
        description={`Are you sure you want to ${alertInfo?.value == true ? 'Approved' : 'Rejected'} Registration ?`}
        onClickClose={() => {
          setAlertInfo({
            visible: false,
            id: null,
            value: null,
          })
        }}
        onClickOk={handleApprovedOrRejected}
      />
    </>
  )
}

export default RequestDoctors
